export default {
  ShowMessage: {
    FirstMessage: 'Tài khoản <span class="color-green">',
    LastMessage:
      '</span> đã phát sinh dữ liệu. Bạn cần chuyển dữ liệu phát sinh vào tài khoản cha để xóa tài khoản này.',
    Title: 'Xóa tài khoản',
    InvalidDetailByInventoryItem:
      'Tài khoản <span class="color-green">{0}</span> đã phát sinh số liệu chi tiết theo Vật tư.',
    InvalidDetailByAccountingObject:
      'Tài khoản <span class="color-green">{0}</span> đã phát sinh số liệu chi tiết theo Đối tượng.',
    InvalidAccountCategoryKind:
      'Tài khoản <span class="color-green">{0}</span> đã phát sinh số liệu. Không thể thay đổi tính chất.',
  },
  ShowMessageDeleteMulti: {
    FirstMessage: 'Tài khoản <span class="color-green">',
    SecondMessage:
      '</span> đã phát sinh dữ liệu vào tài khoản chi tiết. Dữ liệu phát sinh vào tài khoản chi tiết sẽ chuyển sang tài khoản <span class="color-green">',
    ThirdMessage: '</span>. Bạn có muốn thực hiện không?',
    Title: 'Xóa tài khoản tổng hợp',
    BtnYes: 'Đồng ý',
    BtnNo: 'Hủy',
  },
  ConfirmDelete: {
    First: 'Bạn có thực sự muốn xóa tài khoản <span class="color-green"> ',
    Last: '</span> không?',
  },
  DeleteFail: {
    First: 'Các nội dung chi tiết theo của các tài khoản con <span class="color-green">',
    Last: '</span> không giống với tài khoản cha. Không thể xóa các tài khoản này.',
  },
};
